<template>
  <vs-prompt buttons-hidden	class="large" title="تعيين أستاذ" :active="active" @close="close">
    <h4 class="mb-4">قم بادخال البريد إلكتروني لإستاذ لتعيينه في هذه الكلية.</h4>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vs-input
          label-placeholder="البريد الالكتروني"
          name="email"
          data-vv-as="هذا الحقل"
          v-validate="'required|email'"
          icon-pack="feather"
          icon="icon-mail"
          icon-no-border
          v-model="formData.email"
          autocomplete="false"
          class="w-full" />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
      </div>
    </div>
    <vx-divider />
    <div class="flex justify-end">
      <vs-button @click="close" class="mx-5" type="flat">رجوع</vs-button>
      <vs-button @click="submitClicked">حفظ</vs-button>
    </div>
  </vs-prompt>
</template>

<script>
    import teachersAPI from '@/api/admin/teachersAPI'

    export default {
        name: 'TeacherForm',
        props: {
            active: {
                required: true,
                default: false,
                type: Boolean
            },
        },
        watch: {
            active(val){
                if(!val) return

                this.intiValues()
            }
        },
        data () {
            return {
                formData: { email: '' },
            }
        },
        methods: {
            submitClicked(){
                this.$validator.validateAll().then((result) => {
                    if(result) {
                        this.$startLoading()
                        this.assign()
                    }
                })

            },
            assign() {
                teachersAPI.assign({ email: this.formData.email })
                    .then((response) => {
                        let message = response.data.message
                        if(message === 'not_teacher'){
                            this.$notifyWarning('هذا الحساب ليس لإستاذ.')
                        } else if(message === 'exists') {
                            this.$notifyWarning('هذا الحساب موجود في هذه الكلية بالفعل.')
                        } else {
                            this.$emit('submit', Object.assign({}, response.data.user))
                            this.close()
                            this.$notifySuccess(response.successMessage)
                        }
                    })
                    .catch(response => {
                        if(response.status === 404){
                            this.$notifyError('البريد الإلكتروني الذي قمت بإدخالة ليس موجود.')
                        }
                    })
                    .finally(() => this.$closeLoading())
            },
            close(){
                this.$emit('update:active', false)
            },
            intiValues() {
                this.formData = { email: '', }
            },
        },
    }
</script>
